<template>
  <div style="height: 100%" class="bom">
    <SplitContainer2 style="height:100%" layout="horizontal" :split_setting="0.25">
      <template #table1>
        <TableMain name="one table" ref="QuotationTaskItems" :fields="fields2" :title="'quote_apply_detail'" :date_picker_label="'查询条件'"
          :query_button_label="query_lable" :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="false" :show_toolbar="false" :show_filter="false" :isBusy="isBusy" :table_height_adjust="-6"
          :show_toolbar_button="[0, 0, 0, 0, 0]" :hb_table_class="'hb_table_routecost_class1'" :show_query_button="false">
          <template #query>
            <el-form ref="dataForm" label-width="100px" class="mt-1 pl-4">
              <el-col :span="24">
                <el-form-item label="销售公司：" class="mb-0">
                  <el-select size="small" v-model="dataAreaId" filterable clearable placeholder="请选择销售公司" style="width:200px">
                    <el-option v-for="(t,k) in $store.state.biz_data.baseData.CompanyInfo" :key="k" :label="t.DataArea+':'+t.CompanyName"
                      :value="t.DataArea"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="供应商：" class="mb-0">
                  <el-select size="small" v-model="VendAccountNum" filterable clearable placeholder="请选择供应商" style="width:200px">
                    <template v-for="(t,k) in $store.state.biz_data.baseData.CompanyInfo">
                      <el-option v-if="t.VenderAccountNum!=null" :key="k" :label="t.VenderAccountNum+':'+t.CompanyName"
                        :value="t.VenderAccountNum">
                      </el-option>
                    </template>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="物料编号：" class="mb-0">
                  <el-input placeholder="请输入物料编号" v-model="InventNum" style="width:200px" clearable class="mr-1"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="产成品数量：" class="mb-0">
                  <el-input placeholder="请输入产成品数量" v-model="ProductQty" style="width:200px" clearable @input="onInput()"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" style="float:right">
                <el-form-item class="mb-0">
                  <el-button type="danger" @click="getInventRouteCostData"><i class="iconfont icon-system"></i>&nbsp;&nbsp;计算
                  </el-button>
                  <!-- <el-button class="ml-1" type="" @click="on_export"><i class="iconfont icon-print"></i>&nbsp;&nbsp;{{$t('common.export')}}
                  </el-button> -->
                </el-form-item>
              </el-col>
            </el-form>

          </template>
        </TableMain>
      </template>
      <template #table2>
        <CostTree :data1="data1" :data2="data2" :data3="data3" :total_cost="total_cost" :cur_product_qty="total_per_cost"
          :dataAreaId="dataAreaId"></CostTree>
      </template>
    </SplitContainer2>
  </div>
</template>

<script>
import SplitContainer2 from "../components/container/SplitContainer2";
import TableMain from "../components/table/TableMain";
import * as InventBomVersionController from "../../controllers/sd/InventBomVersionController";
import * as CostItemsController from "../../controllers/sd/CostItemsController";
import QueryButton from "../components/base/QueryButton";
import CostTree from "./CostTree.vue";
import { export_json_to_excel_by_list } from "../../shared/Export2Excel";
export default {
  components: {
    SplitContainer2,
    TableMain,
    QueryButton,
    CostTree
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      fields2: CostItemsController.fields.route_cost,
      InventNum: "",
      ProductQty: "",
      BomId: "",
      RouteId: "",
      TransportCost: 0,
      dataAreaId: "",
      VendAccountNum: "",
      current_bom_num: "",
      CurrentActiveTitle: "物料编号：",
      data1: [],
      data2: [],
      data3: [],
      vendOptions: [],
      BomData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      activeCode: "bomcost",
      isBusy: false,
      total_cost: 0,
      total_per_cost: 1,
    }
  },
  created() {
  },
  async mounted() {
    this.vendOptions = await _.filter(this.$store.state.biz_data.baseData.CompanyInfo, (t) => {
      return t.VenderAccountNum != null;
    })
  },
  methods: {

    async getInventRouteCostData() {
      this.InventNum = _.trim(this.InventNum);
      if (this.dataAreaId == "") {
        this.msgToasts("请选择销售公司！", "info");
        return;
      }
      else if (this.VendAccountNum == "") {
        this.msgToasts("请选择供应商！", "info");
        return;
      }
      else if (this.InventNum == "") {
        this.msgToasts("请输入物料编号！", "info");
        return;
      }
      else if (this.ProductQty == "" || this.ProductQty == "0") {
        this.msgToasts("请输入产成品数量！", "info");
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.loading"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.total_cost = 0;
      this.total_per_cost = parseInt(this.ProductQty);
      let _rt = await CostItemsController.methods.execCalcRouteInventQty(
        { ItemId: this.InventNum, ProductQty: this.ProductQty, AccountNum: this.VendAccountNum, dataAreaId: this.dataAreaId, RouteID: '' })
      if (!_.isNull(_rt) && _rt && _rt.length > 0 && parseInt(_rt[0].length) > 0) {
        this.$refs.QuotationTaskItems.SetData(_.orderBy(_rt[0], ["OprNum"], ["asc"]));
        await this.on_query_bom();
      }
      else {
        this.$refs.QuotationTaskItems.SetData([]);
        this.data1 = [];
        this.data2 = [];
        this.data3 = [];
      }
      loading.close();
    },

    async on_query_bom() {
      let p = { SearchText: this.InventNum, Active: 1 }
      let _rt1 = await InventBomVersionController.methods.getDataBySql(p);
      if (!_.isNull(_rt1) && _rt1 && _rt1.length > 0 && _rt1[0].length > 0) {
        let m = _.find(_rt1[0], { dataAreaId: this.dataAreaId });
        if (m) {
          let _rt2 = await CostItemsController.methods.execCalcBomCost(
            { ItemId: this.InventNum, ProductQty: this.ProductQty, AccountNum: this.VendAccountNum, dataAreaId: this.dataAreaId, BomID: m.BOMId, RouteID: "" });
          let _rt3 = await CostItemsController.methods.execCalcRsrcCost(
            { ItemId: this.InventNum, ProductQty: this.ProductQty, AccountNum: this.VendAccountNum, dataAreaId: this.dataAreaId, BomID: m.BOMId, RouteID: "" });

          this.BomData = _rt2;
          this.calcBomCost(m, _rt2) //成本额
          this.calcWrkCtrCost(_rt3) //资源成本
          this.calcCostGroup(m, _rt2) //成本组
        }
      }
    },

    //#region 整理BOM成本额tree
    calcBomCost(mm, dt) {
      let cost_dt = []
      let mt = {
        label: mm.ItemId + "：" + mm.Name,
        ItemId: mm.ItemId,
        purch_price: mm.InventPrice * this.ProductQty,
        invent_cost: 0,
        real_qty: parseFloat(this.ProductQty),
        product_qty: parseFloat(this.ProductQty),
        DW_InventUnitId: "个",
        TEC_SpoilageType: "无",
        children: []
      }
      if (!_.isNull(dt) && dt && dt.length > 0) {
        let md = _.find(dt[0], { DetailItemId: this.InventNum })
        if (md) {
          mt.invent_cost = md.invent_cost
          this.total_cost += md.invent_cost;
        }
        this.buildTreeBomCost(dt[0], this.InventNum, mt)
      }
      cost_dt.push(mt);
      this.data1 = cost_dt
    },
    buildTreeBomCost(dt, ItemId, rt) {
      for (var i in dt) {
        let t = dt[i];
        let mt = {
          label: "【" + t.OprId + "】" + t.DetailItemId + "：" + t.NameAlias,
          ItemId: t.DetailItemId,
          purch_price: t.purch_price ? t.purch_price : 0,
          invent_cost: t.invent_cost ? t.invent_cost : 0,
          real_qty: t.real_qty,
          DW_InventUnitId: t.DW_InventUnitId,
          TEC_SpoilageType: t.TEC_SpoilageType,
          product_qty: parseFloat(this.ProductQty),
          children: []
        }
        if (t.ItemId == ItemId) {
          this.buildTreeBomCost(dt, mt.ItemId, mt)
          rt.children.push(mt);
        }
      }
    },
    //#endregion

    //#region 整理资源tree
    calcWrkCtrCost(dt) {
      let cost_dt = [], order_cost_dt = [];
      if (!_.isNull(dt) && dt && dt.length > 0) {
        let group_rsrc = _.groupBy(dt[0], "ItemId");
        let _seq = 1
        for (var k in group_rsrc) {
          if (k != "undefined") {
            let mt = {
              label: k,
              Electricity: 0,
              LaborCost: 0,
              seq: _seq,
              children: []
            }
            let children = _.uniqBy(group_rsrc[k], "OprNum");
            this.buildTreeWrkCtrCost(children, k, mt);
            cost_dt.push(mt);
            _seq += 1;
          }
        }
        //调整顺序

        _.each(cost_dt, (t) => {
          let pItem = _.find(this.BomData[0], { DetailItemId: t.ItemId });
          let fd = _.find(cost_dt, { ItemId: pItem.ItemId });
          if (fd) {
            fd.Electricity += t.Electricity;
            fd.LaborCost += t.LaborCost;
            fd.children.push(t)
          }
          else {
            order_cost_dt.push(t);
          }
        })
      }
      let dt1 = order_cost_dt;//_.orderBy(cost_dt, ["seq"], ["asc"]);

      this.total_cost += dt1[0].Electricity;
      this.total_cost += dt1[0].LaborCost;
      this.data2 = dt1;
    },
    buildTreeWrkCtrCost(dt, ItemId, rt) {
      let _Electricity = 0, _LaborCost = 0;
      let filter_dt = _.orderBy(dt, ["OprNum"], ["asc"]);
      for (var i in filter_dt) {
        let t = filter_dt[i];
        let _label = t.OprNum + "：" + t.OprId;
        let mt = {
          label: _label,
          Electricity: t.Electricity ? t.Electricity : 0,
          LaborCost: t.LaborCost ? t.LaborCost : 0,
          WrkCtrId: t.WrkCtrId,
          RealQty: t.RealQty ? t.RealQty : "",
          UPH: t.UPH ? t.UPH : 1,
          SetupTime: t.SetupTime ? t.SetupTime : 0,
          SEI_WorkerCount: t.SEI_WorkerCount ? t.SEI_WorkerCount : 0,
          TEC_EquipPower: t.TEC_EquipPower ? t.TEC_EquipPower : 0,
          cPerWorkerPrice: t.cPerWorkerPrice ? t.cPerWorkerPrice : 0,
          PerWorkerPrice: t.PerWorkerPrice ? t.PerWorkerPrice : 0,
          children: []
        }
        _Electricity += mt.Electricity
        _LaborCost += mt.LaborCost
        rt.children.push(mt);
      }
      rt.label = ItemId + "：" + dt[0].NameAlias
      rt.Electricity = _Electricity;
      rt.LaborCost = _LaborCost;
      rt.ItemId = ItemId;
      rt.id = ItemId;
      if (ItemId == this.InventNum) {
        rt.id = "r1";
        rt.seq = 0;
      }
    },
    //#endregion

    //#region 整理成本组tree
    calcCostGroup(mm, dt) {
      let cost_dt = []
      let mt = {
        id: 1,
        label: mm.ItemId + "：" + mm.Name,
        ItemId: mm.ItemId,
        invent_cost: 0,
        real_qty: parseFloat(this.ProductQty),
        price: 0,
        children: []
      }
      if (!_.isNull(dt) && dt && dt.length > 0) {
        let md = _.find(dt[0], { DetailItemId: this.InventNum })
        if (md) {
          mt.invent_cost = md.invent_cost
        }
        this.buildTreeCostGroup(dt[0], this.InventNum, mt)
      }
      let group_cost_group = _.groupBy(mt.children, "CostGroupId");
      let cost_children_dt = [];

      for (var k in group_cost_group) {
        let sum_price = _.sumBy(group_cost_group[k], (t) => {
          return t.invent_cost / parseFloat(this.ProductQty)
        })
        let cost_children_invent_dt = _.map(group_cost_group[k], (t) => {
          return {
            label: t.label,
            price: t.invent_cost / parseFloat(this.ProductQty)
          }
        });
        let m = {
          label: k,
          price: sum_price,
          children: cost_children_invent_dt
        }
        cost_children_dt.push(m);
      }
      mt.children = cost_children_dt;

      ///增加人工成本和电费
      let total_Electricity = this.data2[0].Electricity, total_LaborCost = this.data2[0].LaborCost;
      //人工费
      let lc = {
        id: 20,
        label: "O11人工费",
        LaborCost: total_LaborCost,
        price: total_LaborCost / parseFloat(this.ProductQty),
        cost_type: "O11",
        children: []
      }
      let el_dt1 = _.cloneDeep(this.data2);
      this.changeCostType(el_dt1, "O11");
      lc.children = _.cloneDeep(el_dt1)[0].children;
      _.remove(el_dt1, (t) => { return t.id == "r1" });
      lc.children = _.unionWith(lc.children, el_dt1);
      mt.children.push(lc);
      //电费
      let ep = {
        id: 21,
        label: "O23电费",
        Electricity: total_Electricity,
        price: total_Electricity / parseFloat(this.ProductQty),
        cost_type: "O23",
        children: []
      }
      let el_dt2 = _.cloneDeep(this.data2);
      this.changeCostType(el_dt2, "O23");
      ep.children = _.cloneDeep(el_dt2)[0].children;
      _.remove(el_dt2, (t) => { return t.id == "r1" });
      ep.children = _.unionWith(ep.children, el_dt2);
      mt.children.push(ep);
      // //运输成本
      // let tt = {
      //   id: 22,
      //   label: "运输成本",
      //   TransportCost: this.TransportCost,
      //   cost_type: "O24",
      //   children: []
      // }
      // mt.children.push(tt);
      mt.price = _.sumBy(mt.children, (t) => {
        return t.price
      });
      cost_dt.push(mt);
      this.data3 = cost_dt
    },
    changeCostType(dt, cost_type) {
      for (var k in dt) {
        let t = dt[k]
        t.cost_type = cost_type;
        if (t.children.length > 0) {
          this.changeCostType(t.children, cost_type);
        }
      }
    },
    buildTreeCostGroup(dt, ItemId, rt) {
      for (var i in dt) {
        let t = dt[i];
        let mt = {
          label: t.DetailItemId + "：" + t.NameAlias,
          ItemId: t.ItemId,
          invent_cost: t.invent_cost ? t.invent_cost : 0,
          real_qty: t.real_qty ? t.real_qty : 1,
          CostGroupId: t.CostGroupId,
          children: []
        }
        if (t.ItemId == ItemId) {
          this.buildTreeCostGroup(dt, t.DetailItemId, rt);
          if (t.has_children == 0)
            rt.children.push(mt);
        }
      }
    },
    //#endregion

    onInput() {
      if (this.ProductQty != "") {
        this.ProductQty = parseInt(this.ProductQty.replace(/[^\d]/g, ""));
      }
    },

    // //#region 导出
    // on_export() {
    //   // console.log(this.data1, this.data2, this.data3)
    //   if (this.data1.length == 0 || this.data2.length == 0 || this.data3.length == 0) {
    //     this.msgToasts(this.$t("notify.not_data"), "info");
    //     return;
    //   }
    //   let _loading = this.$loading({
    //     lock: true,
    //     text: this.$t("notify.loading"),
    //     background: "rgba(0, 0, 0, 0.7)"
    //   });
    //   let dt = [], colors = ['507bf3', 'fddf4a', 'f5c4ac', 'f3f586', 'efa2db', 'f37c7c'];
    //   //bom成本额
    //   let sheet1_dt = { sheetName: "BOM成本额", sheetStyle: true, data: [] };
    //   sheet1_dt.data.push({ color: '68aff9', data: ["物料", "总用量", "单位成本", "成本额", "采购价", "级别", "是否末级"] })
    //   this.getSheetData1(this.data1, sheet1_dt, colors, 0)
    //   dt.push(sheet1_dt)
    //   //资源成本
    //   let sheet2_dt = { sheetName: "资源成本", data: [] };
    //   sheet2_dt.data.push(["物料", "资源", "运行时间", "人数", "设备功率", "单位工价", "单位成本", "人工", "电费"])
    //   this.getSheetData2(this.data2, sheet2_dt)
    //   dt.push(sheet2_dt)
    //   //成本组
    //   let sheet3_dt = { sheetName: "成本组", data: [] };
    //   sheet3_dt.data.push(["成本组", "单位成本"])
    //   this.getSheetData3(this.data3, sheet3_dt)
    //   dt.push(sheet3_dt)
    //   export_json_to_excel_by_list(dt, "BOM成本表", _loading);
    // },
    // getSheetData1(dt, p, colors, sq) {
    //   let eps = "", isq = sq * 4;
    //   for (var i = 1; i <= isq; i++) {
    //     eps = eps + " ";
    //   }
    //   sq++;
    //   _.each(dt, (t) => {
    //     let m = [];
    //     m.push(eps + t.label);
    //     m.push(t.real_qty);
    //     m.push(_.round((t.invent_cost / t.product_qty), 6));
    //     m.push(t.invent_cost);
    //     m.push(t.purch_price);
    //     m.push(sq);
    //     p.data.push({ color: colors[sq], data: m });
    //     if (t.children && t.children.length > 0) {
    //       m.push('否')
    //       this.getSheetData1(t.children, p, colors, sq);
    //     }
    //     else
    //       m.push('是')
    //   })
    // },
    // getSheetData2(dt, p) {
    //   _.each(dt, (t) => {
    //     let m = [];
    //     m.push(t.label);
    //     m.push(t.WrkCtrId);
    //     let runTime = _.round((t.RealQty / t.UPH + t.SetupTime), 6);
    //     m.push(_.isNaN(runTime) ? "" : runTime);
    //     m.push(t.SEI_WorkerCount);
    //     m.push(t.TEC_EquipPower);
    //     m.push(t.cPerWorkerPrice);
    //     // let rt_str = "";
    //     // if (t.WrkCtrId) {
    //     //   let labels = ["资源：", "运行时间：", "人数：", "设备功率：", "单位工价："];
    //     //   let values = [];
    //     //   values.push(t.WrkCtrId);
    //     //   values.push(_.round((t.RealQty / t.UPH + t.SetupTime), 6));
    //     //   values.push(t.SEI_WorkerCount);
    //     //   values.push(t.TEC_EquipPower);
    //     //   values.push(t.cPerWorkerPrice);
    //     //   for (var i in labels) {
    //     //     rt_str += labels[i] + values[i] + "，"
    //     //   }
    //     //   rt_str = _.trimEnd(rt_str, "，")
    //     // }
    //     // m.push(rt_str);
    //     m.push(_.round(((t.LaborCost + t.Electricity) / this.total_per_cost), 6));
    //     m.push(t.LaborCost);
    //     m.push(t.Electricity);
    //     p.data.push(m);
    //     if (t.children && t.children.length > 0) {
    //       this.getSheetData2(t.children, p);
    //     }
    //   })
    // },
    // getSheetData3(dt, p) {
    //   _.each(dt, (t) => {
    //     let m = [];
    //     m.push(t.label);
    //     if (t.cost_type == 'O11')
    //       m.push(t.LaborCost / this.ProductQty)
    //     else if (t.cost_type == 'O23')
    //       m.push(t.Electricity / this.ProductQty)
    //     else
    //       m.push(t.price);

    //     p.data.push(m);
    //     if (t.children && t.children.length > 0) {
    //       this.getSheetData3(t.children, p);
    //     }
    //   })
    // }
    // //#endregion
  },
}
</script>
<style >
.hb_table_routecost_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 100rem;
}
.bom .el-card__body,
.el-main {
  padding: 0px;
}
</style>

